<template>

    <canvas ref="canvas"
            :width="(p_width_n * p_wallSize_n) + 'px'"
            :height="(p_height_n * p_wallSize_n) + 'px'">
    </canvas>


</template>

<script>

    export default {
        name: "si_maze",
        props:{
            p_width_n:{
                type: Number,
                require: true,
            },
            p_height_n:{
                type: Number,
                require: true,
            },
            p_wallSize_n:{
                type: Number,
                require: true,
            },
            p_color_s:{
                type: String,
                require: true,
            },
            p_lineWidth_n:{
                type: Number,
                require: true,
            }
        },
        methods:{
            m_getCellId_s(mazeCell_o){
                return mazeCell_o.x + "," + mazeCell_o.y
            },
            m_getWallId_s(mazeCell_o1, mazeCell_o2){

                if(mazeCell_o1.x < mazeCell_o2.x || mazeCell_o1.y < mazeCell_o2.y){
                    let swap = mazeCell_o1
                    mazeCell_o1 = mazeCell_o2
                    mazeCell_o2 = swap
                }

                return mazeCell_o1.x + "," + mazeCell_o1.y + "->" + mazeCell_o2.x + "," + mazeCell_o2.y
            },
            m_pathD_s(){


                let mazeSize = 200
                let noWalls_byWallId_s = {}
                let cellToCheck_as = []
                let visitedCell_byCellId_b = {}

                let currentMazeCell_o   = {x : 0, y: 0}
                visitedCell_byCellId_b[this.m_getCellId_s(currentMazeCell_o)] = true
                cellToCheck_as.push(currentMazeCell_o)

                while(cellToCheck_as.length > 0){

                    // cells
                    let leftCell_o      = {x : currentMazeCell_o.x - 1,   y : currentMazeCell_o.y}
                    let rightCell_o     = {x : currentMazeCell_o.x + 1,   y : currentMazeCell_o.y}
                    let topCell_o       = {x : currentMazeCell_o.x,       y : currentMazeCell_o.y - 1}
                    let bottomCell_o    = {x : currentMazeCell_o.x,       y : currentMazeCell_o.y + 1}

                    let unvisitedLeftNeighbour_b  = leftCell_o.x >= 0            && !visitedCell_byCellId_b[this.m_getCellId_s(leftCell_o)]
                    let unvisitedRightNeighbour_b = rightCell_o.x < mazeSize    && !visitedCell_byCellId_b[this.m_getCellId_s(rightCell_o)]
                    let unvisitedTopNeighbour_b   = topCell_o.y >= 0             && !visitedCell_byCellId_b[this.m_getCellId_s(topCell_o)]
                    let unvisitedBottomNeighbour_b= bottomCell_o.y < mazeSize   && !visitedCell_byCellId_b[this.m_getCellId_s(bottomCell_o)]

                    let unvisitedNeighbours_ao = []

                    if(unvisitedLeftNeighbour_b){unvisitedNeighbours_ao.push(leftCell_o)}
                    if(unvisitedRightNeighbour_b){unvisitedNeighbours_ao.push(rightCell_o)}
                    if(unvisitedTopNeighbour_b){unvisitedNeighbours_ao.push(topCell_o)}
                    if(unvisitedBottomNeighbour_b){unvisitedNeighbours_ao.push(bottomCell_o)}

                    if(unvisitedNeighbours_ao.length > 0){
                        let randomNeighbour_o =  unvisitedNeighbours_ao[Math.floor(Math.random()*unvisitedNeighbours_ao.length)]

                        noWalls_byWallId_s[this.m_getWallId_s(currentMazeCell_o, randomNeighbour_o)] = true

                        visitedCell_byCellId_b[this.m_getCellId_s(randomNeighbour_o)] = true
                        cellToCheck_as.push(randomNeighbour_o)

                        currentMazeCell_o = randomNeighbour_o
                    }else{

                        currentMazeCell_o = cellToCheck_as.pop()
                        visitedCell_byCellId_b[this.m_getCellId_s(currentMazeCell_o)] = true
                    }
                }


                let canvas = this.$refs.canvas
                let wallSize_n = 15

                // for(let j=0; j< mazeSize; j++) {
                //     for (let i = 0; i < mazeSize; i++) {
                //
                //         let ctx = canvas.getContext("2d");
                //         ctx.beginPath();
                //         ctx.strokeStyle = "#bba3d0";
                //
                //         if(!noWalls_byWallId_s[this.m_getWallId_s({y: i, x:+j}, {y:i, x: j+1})]){
                //             ctx.moveTo(wallSize_n * i, wallSize_n * j);
                //             ctx.lineTo(wallSize_n * (i+1), wallSize_n * (j ));
                //             ctx.save();
                //         }
                //
                //         if(!noWalls_byWallId_s[this.m_getWallId_s({y: i, x:+j}, {y:i+1, x: j})]) {
                //             ctx.moveTo(wallSize_n * (i), wallSize_n * (j));
                //             ctx.lineTo(wallSize_n * (i), wallSize_n * (j + 1));
                //         }
                //
                //         ctx.stroke();
                //
                //     }
                // }

                // start the animation


                // incrementally draw additional line segments along the path
                let i =1;
                let offset_y_n = 5;
                let offset_x_n = -15;
                let animate = () =>{

                    if (i < this.p_width_n) {
                        requestAnimationFrame(animate);
                    }

                    for (let j = 0; j < this.p_height_n; j++) {

                        // draw a line segment from the last waypoint
                        // to the current waypoint

                        let ctx = canvas.getContext("2d");
                        ctx.beginPath();
                        ctx.strokeStyle = this.p_color_s
                        ctx.lineWidth = this.p_lineWidth_n

                        if (!noWalls_byWallId_s[this.m_getWallId_s({y: i, x: +j}, {y: i, x: j + 1})]) {
                            ctx.moveTo(offset_x_n + this.p_wallSize_n * i , offset_y_n + this.p_wallSize_n * j);
                            ctx.lineTo(offset_x_n + this.p_wallSize_n * (i + 1), offset_y_n + this.p_wallSize_n * (j));
                        }

                        if (!noWalls_byWallId_s[this.m_getWallId_s({y: i, x: +j}, {y: i + 1, x: j})]) {
                            ctx.moveTo(offset_x_n + this.p_wallSize_n * (i), offset_y_n + this.p_wallSize_n * (j));
                            ctx.lineTo(offset_x_n + this.p_wallSize_n * (i), offset_y_n + this.p_wallSize_n * (j + 1));
                        }

                        ctx.stroke();

                        // increment "t" to get the next waypoint
                    }
                    i++

                }
                animate();


            },



        },
        mounted(){
            this.m_pathD_s()
        }
    }
</script>

<style scoped lang="scss">

    .class_canvas{
        /*width: 1000px;*/
        position: absolute;
        top: 0;
        z-index: -1;
    }

</style>